"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiAccordion = getMuiAccordion;
function getMuiAccordion(palette) {
  return {
    defaultProps: {
      TransitionProps: {
        timeout: 0
      },
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required'
    },
    styleOverrides: {
      root: {
        '&.Mui-disabled': {
          '.MuiAccordionSummary-content': {
            fontSize: '14px',
            fontWeight: 600,
            lineHeight: '22px'
          },
          backgroundColor: palette.common.white
        },
        '&.Mui-expanded': {
          margin: '0 0 16px'
        },
        '&:before': {
          backgroundColor: palette.common.white
        },
        '&:last-of-type': {
          borderRadius: '4px'
        },
        '.MuiAccordionSummary-root': {
          '&.Mui-expanded': {
            borderBottom: 'none',
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            marginBottom: 0,
            minHeight: 0
          },
          '.MuiAccordionSummary-content': {
            '&.Mui-expanded': {
              padding: '12px 0 16px 12px'
            },
            '.MuiTypography-root': {
              fontSize: '14px',
              fontWeight: 600,
              lineHeight: '22px'
            },
            margin: 0,
            padding: '12px 0 12px 12px'
          },
          '.MuiAccordionSummary-expandIconWrapper': {
            '&.Mui-expanded': {
              padding: '0 0 0 12px'
            },
            color: palette.grey.A700,
            padding: '0 12px 0 0'
          },
          border: "solid 1px ".concat(palette.grey[300]),
          borderRadius: '4px',
          height: '100%',
          minHeight: '48px',
          padding: 0
        },
        '.MuiCollapse-root': {
          '&.MuiCollapse-entered': {
            border: "solid 1px ".concat(palette.grey[300]),
            borderTop: 'none',
            maxHeight: '424px',
            overflow: 'auto'
          },
          '.MuiAccordionDetails-root': {
            color: palette.common.black,
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '22px',
            padding: '0 12px 12px'
          },
          borderBottomLeftRadius: '6px',
          borderBottomRightRadius: '6px',
          borderTop: 'none'
        },
        boxShadow: 'none',
        marginBottom: '16px'
      }
    }
  };
}